document.addEventListener("DOMContentLoaded", function() {
    // Target the main content area that holds all the blog text
    const articleContainer = document.querySelector('.article__section-details.rte');

    if (articleContainer) {
        // Find all top-level <p> tags inside the article container
        const paragraphs = articleContainer.querySelectorAll(':scope > p');
        
        // ==========================================
        // 1. Move the Family Section
        // ==========================================
        const familySection = document.getElementById('family-section');
        const familyTargetParagraph = 5; 
        
        if (familySection && paragraphs.length >= familyTargetParagraph) {
            const targetP = paragraphs[familyTargetParagraph - 1];
            targetP.insertAdjacentElement('afterend', familySection);
        }

        // ==========================================
        // 2. Move the Onesie Wrapper Section
        // ==========================================
        const onesieSection = document.getElementById('onesie-wrapper');
        const onesieTargetParagraph = 11;
        
        if (onesieSection && paragraphs.length >= onesieTargetParagraph) {
            const targetP = paragraphs[onesieTargetParagraph - 1];
            targetP.insertAdjacentElement('afterend', onesieSection);
        }
    }
});